// Formatting utilities
export const formatCurrency = (
  value: number,
  currency: string = "USD",
): string => {
  if (isNaN(value) || !isFinite(value)) return "$0.00";
  const safeCurrency = currency || "USD";
  const dollarValue = value / 100; // All RJ2 currency values are returned in cents.
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: safeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollarValue);
};

export const formatNumber = (value: number): string => {
  if (isNaN(value) || !isFinite(value)) return "0";
  return new Intl.NumberFormat("en-US").format(Math.round(value));
};

/**
 * Formats an optional count with thousands separators, falling back to
 * `placeholder` when the value is missing — e.g. an audience whose membership
 * the segment worker has not computed yet. Use this (or `formatNumber`) for
 * every count surface so they all separate thousands the same way.
 */
export const formatCount = (
  value: number | null | undefined,
  placeholder: string = "-",
): string => (value == null ? placeholder : formatNumber(value));

export const formatCompactNumber = (value: number): string => {
  if (isNaN(value) || !isFinite(value)) return "0";
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
};

export const formatPercent = (value: number): string => {
  if (isNaN(value) || !isFinite(value)) return "0%";
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(value / 100);
};
